namespace $ {

	$mol_style_attach( '$shm_agent_app_session_busy_spin', `
		@keyframes shm_agent_session_busy_spin {
			to { transform: rotate(360deg); }
		}
		[shm_agent_app_session_busy] {
			box-sizing: border-box;
			width: 0.8rem;
			height: 0.8rem;
			border: 2px solid currentColor;
			border-right-color: transparent;
			border-radius: 50%;
			animation: shm_agent_session_busy_spin 0.8s linear infinite;
		}
		[shm_agent_app_session_busy][hidden] {
			display: none;
			animation: none;
		}
	` )

	$mol_style_define( $shm_agent_app, {
		Sessions_page: {
			flex: { basis: '18rem', grow: 0, shrink: 0 },
			minWidth: '18rem',
			Body_content: {
				flex: { grow: 1, shrink: 1, basis: 0 },
				height: '100%',
				maxHeight: '100%',
				padding: 0,
			},
		},
		Sessions_head: {
			flex: { grow: 1 },
		},
		Sessions_settings: {
			flex: { grow: 0, shrink: 0 },
		},
		Sessions_settings_content: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			minWidth: '24rem',
			maxWidth: '32rem',
		},
		Sessions_limits_label: {
			width: '100%',
		},
		Sessions_limits: {
			width: '100%',
			gap: 0,
		},
		Session_limit: {
			width: '100%',
		},
		Session_limit_value: {
			color: $mol_theme.shade,
			whiteSpace: 'nowrap',
		},
		Sessions_model_label: {
			width: '100%',
		},
		Sessions_pick: {
			maxWidth: '18rem',
		},
		Sessions_current: {
			maxWidth: '12rem',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},
		Sessions_panel: {
			flex: { direction: 'column', grow: 0, shrink: 1 },
			padding: $mol_gap.block,
			paddingRight: '0px',
			gap: $mol_gap.block,
			width: '18rem',
			maxWidth: 'calc(100vw - 2rem)' as any,
			minHeight: 0,
			maxHeight: '70vh' as any,
			'[standalone]': {
				true: {
					flex: { grow: 1, shrink: 1, basis: 0 },
					width: '100%',
					maxWidth: 'none',
					maxHeight: 'none',
				},
			},
		},
		Sessions_scroll: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minHeight: 0,
			minWidth: 0,
			width: '100%',
			maxWidth: '100%',
		},
		Sessions: {
			minWidth: 0,
			width: '100%',
			maxWidth: '100%',
			gap: 0,
		},
		No_session: {
			padding: $mol_gap.block,
			color: $mol_theme.shade,
		},
		Session: {
			'[pinned]': {
				true: {
					Session_title: { font: { weight: 'bold' } },
				},
			},
			'[archived]': {
				true: {
					Session_link: { opacity: .5 },
					Session_menu: { opacity: .5 },
				},
			},
			display: 'flex',
			minWidth: 0,
			width: '100%',
			maxWidth: '100%',
			align: { items: 'center' },
			justifyContent: 'flex-start',
			textAlign: 'left',
			whiteSpace: 'normal',
			wordBreak: 'break-word',
			'[current]': {
				true: {
					color: $mol_theme.current,
				},
			},
		},
		Session_link: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
			width: 0,
			maxWidth: 'calc(100% - 2.5rem)' as any,
			overflow: 'hidden',
			padding: $mol_gap.text,
		},
		Session_menu: {
			flex: { grow: 0, shrink: 0 },
			width: '2.5rem',
			Trigger: {
				width: '100%',
				minWidth: 0,
				padding: $mol_gap.text,
			},
			Menu_trigger: {
				padding: 0,
			},
		},
		Session_tag_new_bar: {
			width: '100%',
			gap: 0,
		},
		Session_tag_new: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
		},
		Session_tags: {
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			color: $mol_theme.shade,
			font: { size: '0.75rem' },
			whiteSpace: 'nowrap',
		},
		Session_info: {
			flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
			width: '100%',
			overflow: 'hidden',
			align: { items: 'stretch' },
		},
		Session_title: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},
		Session_title_row: {
			width: '100%',
			minWidth: 0,
			overflow: 'hidden',
			gap: '0.375rem',
			align: { items: 'center' },
		},
		Session_markers: {
			flex: { grow: 0, shrink: 0 },
			gap: '0.25rem',
			align: { items: 'center' },
		},
		Session_busy: {
			flex: { grow: 0, shrink: 0 },
			color: $mol_theme.shade,
		},
		Session_unread: {
			width: '0.75rem',
			color: $mol_theme.current,
			font: { size: '0.65rem' },
		},
		Session_meta: {
			gap: $mol_gap.text,
			align: { items: 'center' },
			minWidth: 0,
			width: '100%',
			overflow: 'hidden',
			color: $mol_theme.shade,
			font: { size: '0.75rem' },
		},
		Session_meta_text: {
			flex: { shrink: 0 },
		},
		Chat_page: {
			flex: { basis: '56rem', grow: 1, shrink: 1 },
			minWidth: '34rem',
			Head: {
				height: '4rem',
				minHeight: '4rem',
				alignItems: 'center',
				flexWrap: 'nowrap',
			},
			Title: {
				minWidth: 0,
				minHeight: 0,
				alignItems: 'center',
				flexWrap: 'nowrap',
				gap: 0,
				padding: 0,
				overflow: 'hidden',
			},
			Tools: {
				align: { items: 'center' },
				gap: $mol_gap.text,
			},
			Body_content: {
				flex: { grow: 1, shrink: 1, basis: 0 },
				height: '100%',
				maxHeight: '100%',
				padding: 0,
				paddingLeft: '0.5rem',
			},
		},
		Chat_title: {
			minWidth: 0,
			width: 0,
			padding: '0.5rem',
			flex: { grow: 1, shrink: 1, basis: 0 },
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},
		Chat_provider: {
			margin: { left: '0.5rem' },
			maxWidth: '12rem',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
			color: $mol_theme.shade,
			font: { size: '0.75rem' },
		},
		Chat_settings_content: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			minWidth: '22rem',
			maxWidth: '32rem',
		},
		Model_label: {
			width: '100%',
		},
		Goal: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			minWidth: '24rem',
			maxWidth: '32rem',
		},
		Goal_settings: {
			flex: { shrink: 0 },
			'[data-status]': {
				active: { color: $mol_theme.current },
			},
		},
		Goal_settings_icon: {
			'[data-status]': {
				active: { color: $mol_theme.current },
			},
		},
		Goal_head: {
			justifyContent: 'space-between',
			alignItems: 'center',
			gap: $mol_gap.text,
		},
		Goal_title: {
			font: { weight: 'bold' },
		},
		Goal_status: {
			color: $mol_theme.shade,
			font: { size: '0.8rem' },
		},
		Goal_input: {
			minHeight: '7rem',
		},
		Goal_actions: {
			gap: 0,
		},
		Messages_box: {
			position: 'relative',
			flex: { grow: 1, shrink: 1, basis: 0 },
			height: '100%',
			minHeight: 0,
			minWidth: 0,
		},
		Messages: {
			flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
			width: '100%',
			height: '100%',
			minHeight: 0,
			overflow: 'auto',
			gap: $mol_gap.text,
			padding: { top: '0.5rem', right: $mol_gap.text, bottom: $mol_gap.block },
		},
		Message: {
			flex: { direction: 'column', shrink: 0 },
			gap: $mol_gap.text,
			padding: { left: $mol_gap.block, right: $mol_gap.block, top: $mol_gap.text, bottom: $mol_gap.block },
			border: { radius: $mol_gap.round },
			background: { color: $mol_theme.card },
			'@': {
				role: {
					systemEvent: {
						background: { color: $mol_theme.hover },
						border: { style: 'solid', width: '1px', color: $mol_theme.line },
					},
				},
				queued: {
					true: {
						opacity: 0.8,
						border: { style: 'dashed', width: '1px', color: $mol_theme.line },
					},
				},
			},
		} as any,
		Message_head: {
			color: $mol_theme.shade,
			font: { size: '0.8rem' },
			gap: $mol_gap.text,
			align: { items: 'center' },
		},
		Message_reasoning_link: {
			minHeight: '2rem',
			margin: { left: $mol_gap.text },
			padding: { top: 0, bottom: 0 },
			align: { items: 'center' },
			gap: $mol_gap.text,
			font: { size: '0.8rem' },
		},
		Message_copy: {
			width: '2rem',
			height: '2rem',
			minWidth: '2rem',
			minHeight: '2rem',
			padding: 0,
			flex: { shrink: 0 },
			align: { items: 'center' },
			justifyContent: 'center',
		},
		Message_copy_icon: {
			width: '1rem',
			height: '1rem',
			flex: { shrink: 0 },
		},
		Message_time: {
			margin: { left: 'auto' },
		},
		Message_text_box: {
			flex: { direction: 'column', shrink: 0 },
			gap: $mol_gap.text,
			minHeight: 0,
			minWidth: 0,
			width: '100%',
		},
		Message_text: {
			flex: { grow: 0, shrink: 0, basis: 'auto' },
			minWidth: 0,
			whiteSpace: 'pre-wrap',
			wordBreak: 'break-word',
			Paragraph: {
				padding: 0,
			},
			Header: {
				padding: 0,
			},
		},
		Reasoning_page: {
			flex: { basis: '30rem', grow: 1, shrink: 0 },
			Body_content: {
				flex: { grow: 1, shrink: 1, basis: 0 },
				height: '100%',
				maxHeight: '100%',
			},
		},
		File_page: {
			flex: { basis: '40rem', grow: 1, shrink: 0 },
			minWidth: '28rem',
			Body_content: {
				flex: { grow: 1, shrink: 1, basis: 0 },
				height: '100%',
				maxHeight: '100%',
				padding: 0,
			},
		},
		File_code: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
			height: '100%',
			overflow: 'auto',
		},
		Reasoning_status: {
			color: $mol_theme.shade,
		},
		Reasoning_parts: {
			flex: { grow: 1, shrink: 1, basis: 0, direction: 'column' },
			width: '100%',
			height: '100%',
			minHeight: 0,
			overflow: 'auto',
			gap: $mol_gap.text,
			padding: { top: $mol_gap.block },
		},
		Reasoning_part: {
			flex: { shrink: 0, direction: 'column' },
			gap: $mol_gap.text,
			padding: { left: $mol_gap.block, right: $mol_gap.block, top: $mol_gap.text, bottom: $mol_gap.block },
		},
		Reasoning_part_title: {
			color: $mol_theme.shade,
			font: { size: '0.8rem' },
		},
		Reasoning_part_text: {
			minWidth: 0,
			Paragraph: { padding: 0 },
			Header: { padding: 0 },
		},
		Message_images: {
			flex: { direction: 'row', wrap: 'wrap' },
			gap: $mol_gap.text,
			width: '100%',
		},
		Message_videos: {
			flex: { direction: 'row', wrap: 'wrap' },
			gap: $mol_gap.text,
			width: '100%',
		},
		Message_error: {
			color: $mol_theme.special,
			font: { size: '0.8rem' },
		},
		Activity_error: {
			color: $mol_theme.special,
			font: { size: '0.8rem' },
			padding: { left: $mol_gap.block, right: $mol_gap.block },
		},
		Message_state: {
			color: $mol_theme.shade,
			font: { size: '0.8rem' },
		},
		Message_actions: {
			width: '100%',
			justifyContent: 'flex-end',
		},
		Message_force: {
			flex: { shrink: 0 },
		},
		Message_remove: {
			flex: { shrink: 0 },
		},
		Reply_loader: {
			flex: { shrink: 0 },
			align: { items: 'center' },
			gap: '0.3rem',
			width: 'fit-content',
			padding: { left: $mol_gap.block, right: $mol_gap.block, top: $mol_gap.text, bottom: $mol_gap.text },
			border: { radius: $mol_gap.round },
			background: { color: $mol_theme.card },
		},
		Reply_elapsed: {
			color: $mol_theme.shade,
			font: { size: '0.8rem', family: 'monospace' },
			padding: { right: '0.5rem' },
		},
		Composer: {
			flex: { direction: 'column', grow: 0, shrink: 0, basis: 'auto' },
			gap: $mol_gap.text,
			width: '100%',
			minHeight: '7rem',
			minWidth: 0,
			padding: 0,
			'@': {
				drag: {
					true: {
						boxShadow: `inset 0 0 0 1px ${ $mol_theme.current }`,
						background: { color: $mol_theme.hover },
					},
				},
			},
		},
		Composer_row: {
			align: { items: 'flex-start' },
			flex: { wrap: 'wrap' },
			gap: 0,
			width: '100%',
			minWidth: 0,
		},
		Composer_actions: {
			flex: { shrink: 0 },
			align: { items: 'flex-start' },
			gap: 0,
			margin: { right: '2.5rem' },
			'[busy]': {
				true: {
					margin: { right: 0 },
				},
			},
		},
		Composer_attachments: {
			flex: { direction: 'row' },
			gap: $mol_gap.text,
			width: '100%',
			overflow: 'auto',
		},
		Attachment: {
			align: { items: 'center' },
			gap: $mol_gap.text,
			minWidth: '12rem',
			maxWidth: '20rem',
			padding: $mol_gap.text,
			background: { color: $mol_theme.hover },
			border: { radius: $mol_gap.round },
		},
		Attachment_image: {
			width: '3rem',
			height: '3rem',
			objectFit: 'cover',
			border: { radius: $mol_gap.round },
		},
		Attachment_name: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},
		Attachment_remove: {
			padding: $mol_gap.text,
		},
		Prompt: {
			height: 'auto',
			minHeight: '7rem',
			maxHeight: '40vh',
			overflow: 'auto',
			flex: { grow: 1, shrink: 1, basis: '12rem' },
			minWidth: 0,
		},
		Send: {
			height: '1rem',
			flex: { shrink: 0 },
		},
		Stop: {
			flex: { shrink: 0 },
			height: '1rem',
		},
		'@media': {
			'(max-width: 640px)': {
				Sessions_page: {
					width: '100%',
					minWidth: '100%',
					flex: { basis: '100%', grow: 1, shrink: 1 },
				},
				Chat_page: {
					width: '100%',
					minWidth: '100%',
					flex: { basis: '100%', grow: 1, shrink: 1 },
					Body_content: {
						paddingLeft: '0',
					},
				},
				Goal: {
					width: '100%',
					minWidth: 0,
					maxWidth: '100vw',
				},
				Composer_actions: {
					margin: 0,
				},
			},
		},
	} )

}
